import React, { FunctionComponent, useState, useCallback } from 'react';
import errorHandler from '../../../../../common/service/errorHandler';
import { carsApi } from '../../../../../common/api/carsApi';
import carConfigurationSelectors from '../../../../store/selectors/carConfigurationSelectors';
import { IButtonClickAction } from '../../../presentational/actionButtons/ActionButtons';
import Submit from '../../../presentational/actionButtons/customiseSubmit/Submit';
import { useSelector } from 'react-redux';
import IActionButtonProps from '../IActionButtonProps';
import urlMinify from '../../../../../common/utils/urlMinify';
import { ICarDetails } from '../../../../../../../common/model/ICarDetails';

const SubmitCarToUrlButtonContainer: FunctionComponent<IActionButtonProps> = ({ config }) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const carConfiguration = useSelector(carConfigurationSelectors.getConfiguration);

  const onClick: IButtonClickAction = useCallback(async () => {
    setIsSubmitting(true);

    if (config.carSubmissionURL && carConfiguration) {
      const minifiedConfigurationUrl = await urlMinify.shorten(carConfiguration.configurationSourceUrl);
      const updatedCarConfiguration: ICarDetails = {
        ...carConfiguration,
        configurationSourceUrl: minifiedConfigurationUrl,
      };

      return carsApi.submitCarConfigToForm(updatedCarConfiguration, config.carSubmissionURL);
    }

    return new Promise((_resolve, reject) => {
      errorHandler.handleError(config);
      reject(new Error('Redirection should have happened'));
    });
  }, [carConfiguration]);

  return <Submit onClick={onClick} disabled={isSubmitting || config.disabled} />;
};

export default SubmitCarToUrlButtonContainer;
